// extracted by mini-css-extract-plugin
module.exports = {"labelFlex":"param-form_labelFlex_e8WKJ","leftLabel":"param-form_leftLabel_1lwAH","rightLabel":"param-form_rightLabel_1IfG5"};